import {
    requestApi
} from '@/util/network.js';
// import {}

/* **************登录start********************** */
// 注册
export const register =
    (data) =>
        requestApi(
            'register',
            'POST',
            data
        )

// 发送验证码
export const set_code =
    (data) =>
        requestApi(
            'set_code',
            'POST',
            data,
        )
// 登录
export const login =
    (data) =>
        requestApi(
            'login',
            'POST',
            data
        )
// 忘记密码
export const resetPassword
    =
    (data) =>
        requestApi(
            'resetPassword',
            'POST',
            data
        )
/* **************登录end********************** */
/* **************个人中心start********************** */
// 退出
export const logout =
    (data) =>
        requestApi(
            'login/out',
            'POST',
            data
        )
// 修改账户资料
export const edit =
    (data) =>
        requestApi(
            'user/edit',
            'POST',
            data
        )
// 获取用户信息
export const getUserInfo =
    (data) =>
        requestApi(
            'user',
            'POST',
            data
        )
// 修改密码
export const editpass =
    (data) =>
        requestApi(
            'user/editpass',
            'POST',
            data
        )
// 修改手机号
export const editmobile =
    (data) =>
        requestApi(
            'user/editmobile',
            'POST',
            data
        )
// 获取城市
export const getCity =
    (data) =>
        requestApi(
            'city',
            'POST',
            data
        )
/* **************个人中心end********************** */
/* **************测试start********************** */
// 兴趣
export const interest =
    (data) =>
        requestApi(
            'interest',
            'POST',
            data
        )
// 能力
export const power =
    (data) =>
        requestApi(
            'power',
            'POST',
            data
        )
// 性格
export const character =
    (data) =>
        requestApi(
            'character',
            'POST',
            data
        )
// 兴趣提交
export const interestResults =
    (data) =>
        requestApi(
            'interest/results',
            'POST',
            data
        )
// 能力提交
export const powerResults =
    (data) =>
        requestApi(
            'power/results',
            'POST',
            data
        )
// 性格提交
export const characterResults =
    (data) =>
        requestApi(
            'character/results',
            'POST',
            data
        )
// 历史测评
export const history =
    (data) =>
        requestApi(
            'interest/history',
            'POST',
            data
        )
// 下载文档
export const downWord =
    (data) =>
        requestApi(
            'down',
            'POST',
            data
        )
// 查询是否答过题
export const possible =
    (data) =>
        requestApi(
            'possible',
            'POST',
            data
        )
// 保存统计图
export const resultsImg =
    (data) =>
        requestApi(
            'results/img',
            'POST',
            data
        )
// 上传base64图片
export const uplaodBase64img =
    (data) =>
        requestApi(
            false,
            'POST',
            data,
            true,
            'uplaodimg/base64'

    )
// 查询是否支付成功
export const payStatus =
    (data) =>
        requestApi(
            'pay/status',
            'POST',
            data,
            true,
    )
// 获取付款吗
export const getCode = (data) =>
        requestApi(
            'get/code',
            'POST',
            data,
            true,
    )
    // 选科提交
export const courseResults =
    (data) =>
        requestApi(
            'course/results',
            'POST',
            data
        )
        // 选科
export const course =
    (data) =>
        requestApi(
            'course',
            'POST',
            data
        )
// 能力
export const list =
    (data) =>
        requestApi(
            'list',
            'POST',
            data
        )
        // 修改密码
export const checkpass =
    (data) =>
        requestApi(
            'course/pass',
            'POST',
            data
        )